<template>
	<div>
		<input ref="uploadFileBtn" type="file" @change="fileChange" hidden />
		<b-form-group ref="proxyValue" label-for="group-filename">
			<b-input-group id="group-filename">
				<b-form-input :value="fileName != '' ? fileName : fieldInfo.placeholder" disabled class="b-0"></b-form-input>
				<b-input-group-append>
					<k-icon-button
						v-if="!fileName"
						icon="upload"
						variant="secondary"
						@click="uploadFile()"
						:textTooltip="$t('commons.hovers.uploadFile')"
					/>
					<k-icon-button v-if="fileName" icon="x" variant="danger" @click="deleteFile()" :tooltip="$t('commons.hovers.deleteFile')" />
				</b-input-group-append>
			</b-input-group>
		</b-form-group>
		<p class="message">{{ $t("components.kInputFileNew.message") }}</p>

		<b-form-invalid-feedback :id="`${fieldInfo.name}-feedback`">
			{{ errors[fieldInfo.name] }}
		</b-form-invalid-feedback>
	</div>
</template>
<script>
import KIconButton from "../Buttons/KIconButton.vue";
export default {
	components: { KIconButton },
	props: {
		value: {
			type: [String, File]
		},
		fieldInfo: {
			type: Object
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		}
	},
	data() {
		return { fileName: "" };
	},
	computed: {
		uploadFileBtn: {
			get() {
				let file = event.target.files[0];
				this.$emit("input", file);
				return file;
			}
		}
	},
	methods: {
		fileChange: function (event) {
			let file = event.target.files[0];
			this.fileName = file.name;
			this.$emit("fileChange", file);
			this.uploadFileBtn;
		},
		uploadFile: function () {
			this.$refs.uploadFileBtn.click();
		},
		deleteFile: function () {
			this.fileName = "";
			this.$refs.uploadFileBtn.value = null;
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		}
	},
	beforeMount() {
		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;
	}
};
</script>

<style>
btn-secondary {
	color: #666666;
	background-color: #d6d6d6;
	border-color: #d6d6d6;
}
.message {
	font-weight: 400;
	font-size: 10px;
	text-align: left;
}
</style>
